import React, { ChangeEvent } from "react";

interface CheckboxInterface {
  id: string;
  label?: string;
  isChecked: boolean;
  onChange: (id: string, checked: boolean) => void;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxInterface> = ({
  id,
  isChecked,
  onChange,
  disabled,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(id, event.target.checked);
    }
  };

  return (
    <input
      id={id}
      type="checkbox"
      checked={isChecked}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

export default Checkbox;
